export default __webpack_public_path__ + "static/media/colin_berger.380fdf89.png";